export default __webpack_public_path__ + "static/media/jogar365_receipt.28707593.png";